import { isEmpty as empty, isNil } from 'lodash';

import { isPrimitive } from './is-primitive';

const isEmptyObject = (value: any) => !isPrimitive(value) && empty(value);
const isEmptyPrimitive = (value: any) => isPrimitive(value) && empty(value?.toString()?.trim());

export const isEmpty = (value: any) => isNil(value) || isEmptyPrimitive(value) || isEmptyObject(value);
